import * as swcHelpers from '@swc/helpers';
import { DataLayer, calcPrice } from '@grandvisionhq/analytics';
import { Locales } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';

const getOrderLineItemSharedAttributes = (locale, lineItem, lineItemType, purchaseType)=>{
    var ref;
    const localizedName = lineItem.product.name.map(DataLayer.DataLayerUtils.formatAttribute);
    const exclusiveBrand = 'exclusiveBrand' in lineItem.product ? lineItem.product.exclusiveBrand : false;
    const isOnStock = 'isOnStock' in lineItem.product ? lineItem.product.isOnStock : false;
    var ref1;
    return {
        name: localizedName ? DataLayer.DataLayerUtils.transformValue(localizedName, locale) : '',
        id: lineItem.product.sku || '',
        price: `${(ref1 = calcPrice(lineItem === null || lineItem === void 0 ? void 0 : lineItem.price.unit.gross)) !== null && ref1 !== void 0 ? ref1 : ''}`,
        dimension143: purchaseType ? purchaseType : DataLayer.DataLayerTypes.PurchaseType.OneTime,
        dimension144: lineItemType,
        dimension145: 'true',
        dimension190: lineItem.product.erpId || '',
        dimension193: exclusiveBrand ? DataLayer.DataLayerTypes.BrandType.OwnBrand : DataLayer.DataLayerTypes.BrandType.ExternalBrand,
        dimension194: isOnStock ? DataLayer.DataLayerTypes.Stock.InStock : DataLayer.DataLayerTypes.Stock.OutOfStock,
        metric140: `${calcPrice(lineItem === null || lineItem === void 0 ? void 0 : lineItem.price.unit.subtotal) || ''}` || '',
        metric141: `${calcPrice(lineItem === null || lineItem === void 0 ? void 0 : lineItem.price.unit.discount.amount) || ''}`,
        metric142: `${calcPrice(lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.price) === null || ref === void 0 ? void 0 : ref.unit.tax.amount) || ''}`,
        quantity: lineItem.quantity
    };
};
const getOrderLineItemSunglassesAttributes = (locale, lineItem)=>{
    var ref, ref2, ref3, ref4, ref5, ref6;
    const sharedAttributes = getOrderLineItemSharedAttributes(locale, lineItem, DataLayer.DataLayerTypes.LineItemType.Single);
    const productMetaData = lineItem.product.additionalProductDetails;
    const frameShape = productMetaData === null || productMetaData === void 0 ? void 0 : (ref = productMetaData.frameShape) === null || ref === void 0 ? void 0 : ref.map(DataLayer.DataLayerUtils.formatAttribute);
    const frameType = productMetaData === null || productMetaData === void 0 ? void 0 : (ref2 = productMetaData.frameType) === null || ref2 === void 0 ? void 0 : ref2.map(DataLayer.DataLayerUtils.formatAttribute);
    const faceShape = productMetaData === null || productMetaData === void 0 ? void 0 : (ref3 = productMetaData.faceShape) === null || ref3 === void 0 ? void 0 : ref3.map(DataLayer.DataLayerUtils.formatAttributes);
    const gender = productMetaData === null || productMetaData === void 0 ? void 0 : (ref4 = productMetaData.gender) === null || ref4 === void 0 ? void 0 : ref4.map(DataLayer.DataLayerUtils.formatAttributes);
    const frameMaterial = productMetaData === null || productMetaData === void 0 ? void 0 : (ref5 = productMetaData.frameMaterial) === null || ref5 === void 0 ? void 0 : ref5.map(DataLayer.DataLayerUtils.formatAttribute);
    const frameColor = productMetaData === null || productMetaData === void 0 ? void 0 : (ref6 = productMetaData.frameColor) === null || ref6 === void 0 ? void 0 : ref6.map(DataLayer.DataLayerUtils.formatAttributes);
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Sunglasses,
        brand: lineItem.product.brand || ''
    }, DataLayer.DataLayerUtils.transformToEventPayload({
        dimension147: frameColor,
        dimension16: gender,
        dimension146: frameMaterial,
        variant: frameShape,
        locale
    }), {
        dimension191: frameType ? DataLayer.DataLayerUtils.transformValue(frameType, locale).toLowerCase() : '',
        dimension192: faceShape ? DataLayer.DataLayerUtils.transformValue(faceShape, locale).toLowerCase() : '',
        dimension140: lineItem.product.sku || ''
    });
};
const getOrderPrescriptionSunglassesAttributes = (locale, lineItem)=>{
    var ref, ref7, ref8, ref9;
    const sharedAttributes = getOrderLineItemSharedAttributes(locale, lineItem, DataLayer.DataLayerTypes.LineItemType.Bundle);
    const category = DataLayer.DataLayerTypes.Category.Sunglasses;
    const name = (ref = lineItem.product) === null || ref === void 0 ? void 0 : (ref7 = ref.name) === null || ref7 === void 0 ? void 0 : ref7.map(DataLayer.DataLayerUtils.formatAttribute);
    const frameType = (ref8 = lineItem.mainLineItem.product.frameType) === null || ref8 === void 0 ? void 0 : ref8.map(DataLayer.DataLayerUtils.formatAttribute);
    const faceShape = (ref9 = lineItem.mainLineItem.product.faceShape) === null || ref9 === void 0 ? void 0 : ref9.map(DataLayer.DataLayerUtils.formatAttributes);
    const isOnStock = lineItem.mainLineItem.product.isOnStock;
    const erpId = lineItem.mainLineItem.product.erpId;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: name ? DataLayer.DataLayerUtils.transformValue(name, locale) : '',
        brand: lineItem.product.brand || '',
        category,
        variant: '',
        dimension16: '',
        dimension146: '',
        dimension147: '',
        dimension140: lineItem.product.sku || '',
        dimension190: erpId || '',
        dimension191: frameType ? DataLayer.DataLayerUtils.transformValue(frameType, locale).toLowerCase() : '',
        dimension192: faceShape ? DataLayer.DataLayerUtils.transformValue(faceShape, locale).toLowerCase() : '',
        dimension194: isOnStock ? DataLayer.DataLayerTypes.Stock.InStock : DataLayer.DataLayerTypes.Stock.OutOfStock
    });
};
const getOrderPrescriptionGlassesAttributes = (locale, lineItem)=>{
    var ref, ref10, ref11, ref12;
    const sharedAttributes = getOrderLineItemSharedAttributes(locale, lineItem, DataLayer.DataLayerTypes.LineItemType.Bundle);
    const category = DataLayer.DataLayerTypes.Category.Optical;
    const name = (ref = lineItem.product) === null || ref === void 0 ? void 0 : (ref10 = ref.name) === null || ref10 === void 0 ? void 0 : ref10.map(DataLayer.DataLayerUtils.formatAttribute);
    const frameType = (ref11 = lineItem.mainLineItem.product.frameType) === null || ref11 === void 0 ? void 0 : ref11.map(DataLayer.DataLayerUtils.formatAttribute);
    const faceShape = (ref12 = lineItem.mainLineItem.product.faceShape) === null || ref12 === void 0 ? void 0 : ref12.map(DataLayer.DataLayerUtils.formatAttributes);
    const isOnStock = lineItem.mainLineItem.product.isOnStock;
    const erpId = lineItem.mainLineItem.product.erpId;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: name ? DataLayer.DataLayerUtils.transformValue(name, locale) : '',
        brand: lineItem.product.brand || '',
        category,
        variant: '',
        dimension16: '',
        dimension146: '',
        dimension147: '',
        dimension140: lineItem.product.sku || '',
        dimension190: erpId || '',
        dimension191: frameType ? DataLayer.DataLayerUtils.transformValue(frameType, locale).toLowerCase() : '',
        dimension192: faceShape ? DataLayer.DataLayerUtils.transformValue(faceShape, locale).toLowerCase() : '',
        dimension194: isOnStock ? DataLayer.DataLayerTypes.Stock.InStock : DataLayer.DataLayerTypes.Stock.OutOfStock
    });
};
const getOrderFrameAttributes = (locale, lineItem)=>{
    var ref, ref13, ref14, ref15;
    const sharedAttributes = getOrderLineItemSharedAttributes(locale, lineItem, DataLayer.DataLayerTypes.LineItemType.Bundle);
    const category = DataLayer.DataLayerTypes.Category.Optical;
    const name = (ref = lineItem.product) === null || ref === void 0 ? void 0 : (ref13 = ref.name) === null || ref13 === void 0 ? void 0 : ref13.map(DataLayer.DataLayerUtils.formatAttribute);
    const additionalProductDetails = lineItem.product.additionalProductDetails;
    const frameType = additionalProductDetails === null || additionalProductDetails === void 0 ? void 0 : (ref14 = additionalProductDetails.frameType) === null || ref14 === void 0 ? void 0 : ref14.map(DataLayer.DataLayerUtils.formatAttribute);
    const faceShape = additionalProductDetails === null || additionalProductDetails === void 0 ? void 0 : (ref15 = additionalProductDetails.faceShape) === null || ref15 === void 0 ? void 0 : ref15.map(DataLayer.DataLayerUtils.formatAttributes);
    const isOnStock = lineItem.product.isOnStock;
    const erpId = lineItem.product.erpId;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: name ? DataLayer.DataLayerUtils.transformValue(name, locale) : '',
        brand: lineItem.product.brand || '',
        category,
        variant: '',
        dimension16: '',
        dimension146: '',
        dimension147: '',
        dimension140: lineItem.product.sku || '',
        dimension190: erpId || '',
        dimension191: frameType ? DataLayer.DataLayerUtils.transformValue(frameType, locale).toLowerCase() : '',
        dimension192: faceShape ? DataLayer.DataLayerUtils.transformValue(faceShape, locale).toLowerCase() : '',
        dimension194: isOnStock ? DataLayer.DataLayerTypes.Stock.InStock : DataLayer.DataLayerTypes.Stock.OutOfStock
    });
};
const getOrderNonPrescriptionBundleAttributes = (locale, lineItem)=>{
    var ref, ref16;
    const sharedAttributes = getOrderLineItemSharedAttributes(locale, lineItem, DataLayer.DataLayerTypes.LineItemType.Bundle);
    const category = DataLayer.DataLayerTypes.Category.Optical;
    const name = (ref = lineItem.product) === null || ref === void 0 ? void 0 : (ref16 = ref.name) === null || ref16 === void 0 ? void 0 : ref16.map(DataLayer.DataLayerUtils.formatAttribute);
    const isOnStock = lineItem.product.isOnStock;
    const erpId = lineItem.product.erpId;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: name ? DataLayer.DataLayerUtils.transformValue(name, locale) : '',
        brand: lineItem.product.brand || '',
        category,
        variant: '',
        dimension16: '',
        dimension146: '',
        dimension147: '',
        dimension140: lineItem.product.sku || '',
        dimension190: erpId || '',
        dimension191: '',
        dimension192: '',
        dimension194: isOnStock ? DataLayer.DataLayerTypes.Stock.InStock : DataLayer.DataLayerTypes.Stock.OutOfStock
    });
};
const getOrderLineItemReadyReadersAttributes = (locale, lineItem)=>{
    var ref, ref17, ref18, ref19, ref20, ref21;
    const sharedAttributes = getOrderLineItemSharedAttributes(locale, lineItem, DataLayer.DataLayerTypes.LineItemType.Single);
    const productMetaData = lineItem.product.additionalProductDetails;
    const frameShape = productMetaData === null || productMetaData === void 0 ? void 0 : (ref = productMetaData.frameShape) === null || ref === void 0 ? void 0 : ref.map(DataLayer.DataLayerUtils.formatAttribute);
    const frameType = productMetaData === null || productMetaData === void 0 ? void 0 : (ref17 = productMetaData.frameType) === null || ref17 === void 0 ? void 0 : ref17.map(DataLayer.DataLayerUtils.formatAttribute);
    const faceShape = productMetaData === null || productMetaData === void 0 ? void 0 : (ref18 = productMetaData.faceShape) === null || ref18 === void 0 ? void 0 : ref18.map(DataLayer.DataLayerUtils.formatAttributes);
    const gender = productMetaData === null || productMetaData === void 0 ? void 0 : (ref19 = productMetaData.gender) === null || ref19 === void 0 ? void 0 : ref19.map(DataLayer.DataLayerUtils.formatAttributes);
    const frameMaterial = productMetaData === null || productMetaData === void 0 ? void 0 : (ref20 = productMetaData.frameMaterial) === null || ref20 === void 0 ? void 0 : ref20.map(DataLayer.DataLayerUtils.formatAttribute);
    const frameColor = productMetaData === null || productMetaData === void 0 ? void 0 : (ref21 = productMetaData.frameColor) === null || ref21 === void 0 ? void 0 : ref21.map(DataLayer.DataLayerUtils.formatAttributes);
    return swcHelpers.objectSpread({}, sharedAttributes, {
        brand: lineItem.product.brand || '',
        category: DataLayer.DataLayerTypes.Category.ReadyReaders
    }, DataLayer.DataLayerUtils.transformToEventPayload({
        dimension147: frameColor,
        dimension16: gender,
        dimension146: frameMaterial,
        variant: frameShape,
        locale
    }), {
        dimension140: lineItem.product.sku || '',
        dimension191: frameType ? DataLayer.DataLayerUtils.transformValue(frameType, locale).toLowerCase() : '',
        dimension192: faceShape ? DataLayer.DataLayerUtils.transformValue(faceShape, locale).toLowerCase() : ''
    });
};
const getOrderLineItemAccessoriesAttributes = (locale, lineItem)=>{
    var ref, ref22, ref23, ref24;
    const sharedAttributes = getOrderLineItemSharedAttributes(locale, lineItem, DataLayer.DataLayerTypes.LineItemType.Single);
    const productMetaData = lineItem.product.additionalProductDetails;
    const accessoryType = productMetaData === null || productMetaData === void 0 ? void 0 : (ref = productMetaData.accessoryType) === null || ref === void 0 ? void 0 : ref.map(DataLayer.DataLayerUtils.formatAttribute);
    const gender = productMetaData === null || productMetaData === void 0 ? void 0 : (ref22 = productMetaData.gender) === null || ref22 === void 0 ? void 0 : ref22.map(DataLayer.DataLayerUtils.formatAttributes);
    const material = productMetaData === null || productMetaData === void 0 ? void 0 : (ref23 = productMetaData.material) === null || ref23 === void 0 ? void 0 : ref23.map(DataLayer.DataLayerUtils.formatAttribute);
    const accessoryColor = productMetaData === null || productMetaData === void 0 ? void 0 : (ref24 = productMetaData.accessoryColor) === null || ref24 === void 0 ? void 0 : ref24.map(DataLayer.DataLayerUtils.formatAttributes);
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Accessories,
        brand: lineItem.product.brand || ''
    }, DataLayer.DataLayerUtils.transformToEventPayload({
        variant: accessoryType,
        dimension146: material,
        dimension16: gender,
        dimension147: accessoryColor,
        locale
    }), {
        dimension140: lineItem.product.sku || ''
    });
};
const getOrderLineItemSolutionsAttributes = (locale, lineItem)=>{
    const sharedAttributes = getOrderLineItemSharedAttributes(locale, lineItem, DataLayer.DataLayerTypes.LineItemType.Single);
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Solutions,
        brand: lineItem.product.brand || '',
        variant: 'solution'
    });
};
const getOrderLineItemContactLensesAttributes = (locale, lineItem)=>{
    var ref, ref25, ref26, ref27, ref28;
    const sharedAttributes = getOrderLineItemSharedAttributes(locale, lineItem, lineItem.isSubscription ? DataLayer.DataLayerTypes.LineItemType.Subscription : DataLayer.DataLayerTypes.LineItemType.Single, lineItem.isSubscription ? DataLayer.DataLayerTypes.PurchaseType.Subscription : DataLayer.DataLayerTypes.PurchaseType.OneTime);
    const lenseType = (ref = lineItem.product) === null || ref === void 0 ? void 0 : (ref25 = ref.lensType) === null || ref25 === void 0 ? void 0 : ref25.map(DataLayer.DataLayerUtils.formatAttribute);
    const material = (ref26 = lineItem.product) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.material) === null || ref27 === void 0 ? void 0 : ref27.map(DataLayer.DataLayerUtils.formatAttribute);
    const replacementFrequency = (ref28 = lineItem.product) === null || ref28 === void 0 ? void 0 : ref28.replacementFrequency.map(DataLayer.DataLayerUtils.formatAttribute);
    return swcHelpers.objectSpread({}, sharedAttributes, {
        brand: lineItem.product.brand || '',
        category: DataLayer.DataLayerTypes.Category.ContactLenses,
        variant: lenseType ? DataLayer.DataLayerUtils.transformValue(lenseType, locale) : '',
        dimension148: replacementFrequency ? DataLayer.DataLayerUtils.transformValue(replacementFrequency, locale) : '',
        dimension146: material ? DataLayer.DataLayerUtils.transformValue(material, locale) : '',
        dimension140: lineItem.product.sku || ''
    });
};
const orderLineItemToProductItem = (lineItem)=>{
    var ref;
    const productType = (ref = lineItem.product.currentProduct) === null || ref === void 0 ? void 0 : ref.type.toLowerCase();
    if (!productType) {
        return;
    }
    switch(productType){
        case 'sunglasses':
            {
                if (lineItem.__typename == 'OrderLineItemRegular') {
                    return getOrderLineItemSunglassesAttributes(Locales['en-GB'], lineItem);
                } else if (lineItem.__typename === 'OrderLineItemPrescriptionGlass') {
                    return getOrderPrescriptionSunglassesAttributes(Locales['en-GB'], lineItem);
                } else {
                    break;
                }
            }
        case 'contact-lenses':
        case 'contact_lenses':
            {
                if (lineItem.__typename === 'OrderLineItemContactLens') {
                    return getOrderLineItemContactLensesAttributes(Locales['en-GB'], lineItem);
                } else {
                    break;
                }
            }
        case 'solutions':
            {
                if (lineItem.__typename === 'OrderLineItemRegular' || lineItem.__typename === 'OrderLineItemSolution') {
                    return getOrderLineItemSolutionsAttributes(Locales['en-GB'], lineItem);
                } else {
                    break;
                }
            }
        case 'ready_readers':
            {
                if (lineItem.__typename === 'OrderLineItemRegular') {
                    return getOrderLineItemReadyReadersAttributes(Locales['en-GB'], lineItem);
                } else {
                    break;
                }
            }
        case 'accessories':
            {
                if (lineItem.__typename === 'OrderLineItemRegular') {
                    return getOrderLineItemAccessoriesAttributes(Locales['en-GB'], lineItem);
                } else {
                    break;
                }
            }
        case 'frames':
            {
                // Regular prescription glasses
                if (lineItem.__typename === 'OrderLineItemPrescriptionGlass') {
                    return getOrderPrescriptionGlassesAttributes(Locales['en-GB'], lineItem);
                } else if (lineItem.__typename === 'OrderLineItemNonPrescriptionBundle') {
                    return getOrderNonPrescriptionBundleAttributes(Locales['en-GB'], lineItem);
                } else if (lineItem.__typename === 'OrderLineItemRegular') {
                    return getOrderFrameAttributes(Locales['en-GB'], lineItem);
                } else {
                    break;
                }
            }
        case 'non_prescription_bundle':
            {
                if (lineItem.__typename === 'OrderLineItemNonPrescriptionBundle') {
                    return getOrderNonPrescriptionBundleAttributes(Locales['en-GB'], lineItem);
                } else {
                    break;
                }
            }
    }
    console.error(`No analytics mapper found for line-item: `, lineItem);
};
const mapOrderLineItemToDataLayerProductObjects = (lineItems)=>{
    return (lineItems === null || lineItems === void 0 ? void 0 : lineItems.map(orderLineItemToProductItem).filter(isDefined)) || [];
};

export { getOrderLineItemSharedAttributes, mapOrderLineItemToDataLayerProductObjects };
//# sourceMappingURL=data-layer.js.map
